import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { StatusColorMap } from '../editor/fields/helpers/editor-fields-helper';

type TaskStatus = 'Open' | 'In Progress' | 'Complete';
type IssueStatus = 'Needs resolution' | 'Resolved';
type StatusEnum = TaskStatus | IssueStatus;

interface Props {
  value: StatusEnum;
  size?: number;
  height?: number;
  capitalized?: boolean;
}

const StatusIndicator = styled('span', {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: number }>(({ size }) => ({
  width: size,
  height: size,
  borderRadius: '20px',
  marginRight: '8px',
  paddingRight: '8px',
}));

const StatusCell = styled('div', {
  shouldForwardProp: (prop) => prop !== 'capitalized' && prop !== 'height',
})<{ capitalized?: boolean, height?: number }>(({ capitalized, height }) => ({
  height,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'start',
  textTransform: (capitalized ? 'capitalize' : 'uppercase'),
  alignItems: 'center',
  pointerEvents: 'none',
}));

export default function StatusColumn({
  value, size = 9, capitalized = false, height = 52,
}: Props) {
  const statusColor: string = value ? StatusColorMap[value.toLowerCase()] : '';

  return (
    <StatusCell height={height} capitalized={capitalized}>
      <StatusIndicator size={size} sx={{ background: statusColor }} data-testid={`status-column${value}`} />
      <Typography variant="body2">{value}</Typography>
    </StatusCell>
  );
}
